import React from 'react';
export const useFetchAuto = (request, dependencies) => {
    const requestRef = React.useRef(request);
    const [reloadKey, setReloadKey] = React.useState(0);
    const [state, setState] = React.useState({
        data: undefined,
        error: undefined,
        loading: true,
    });
    requestRef.current = request;
    React.useEffect(() => {
        const controller = new AbortController();
        setState(current => ({ ...current, error: undefined, loading: true }));
        requestRef.current(controller.signal)
            .then(data => setState({ data, error: undefined, loading: false }))
            .catch(error => {
            if (error instanceof DOMException && error.name === 'AbortError')
                return;
            setState(current => ({ ...current, error: error, loading: false }));
        });
        return () => controller.abort();
        // The caller owns the dependency list, matching the original _rad hook.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadKey, ...dependencies]);
    return {
        ...state,
        reload: () => setReloadKey(value => value + 1),
    };
};
export default useFetchAuto;
